import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { LeadHelper } from '../../../../../helper/lead.helper';
import { AddressHelper } from '../../../../../helper/address.helper';
import { LeadsData } from '../../../../../models/leads/leads.model';
import { FiltersAndSorting } from '../requests-overview-content.component';

@Component({
  selector: 'fi-requests-overview-mobile-container',
  templateUrl: './requests-overview-mobile-container.component.html',
  styleUrls: ['./requests-overview-mobile-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RequestsOverviewMobileContainerComponent {
  @Input() contactLeads: LeadsData[];
  @Input() compactView$: Observable<boolean>;
  @Input() expandedLeads: WeakSet<LeadsData>;
  @Input() leadsCount = 0;
  @Input() visibleLeadsCount = 0;
  @Input() filters: FiltersAndSorting;
  @Input() pagesCount = 0;

  @Output() rejectAssignmentRequested = new EventEmitter<number>();
  @Output() confirmAssignmentRequested = new EventEmitter<number>();
  @Output() toggleExpandedLeadRequested = new EventEmitter<LeadsData>();
  @Output() duplicateClickRequested = new EventEmitter<number>();
  @Output() openLeadDetailsRequested = new EventEmitter<{ id: number; newTab: boolean }>();
  @Output() prevPageRequested = new EventEmitter<void>();
  @Output() nextPageRequested = new EventEmitter<void>();

  readonly leadHelper = LeadHelper;

  trackByLeadId = (_: number, item: any) => item?.Lead?.Id ?? _;

  rejectAssignment(index: number): void { this.rejectAssignmentRequested.emit(index); }
  confirmAssignment(index: number): void { this.confirmAssignmentRequested.emit(index); }
  toggleExpandedLead(lead: LeadsData): void { this.toggleExpandedLeadRequested.emit(lead); }
  onDuplicateClick(index: number): void { this.duplicateClickRequested.emit(index); }
  openLeadDetails(id: number, newTab = false): void { this.openLeadDetailsRequested.emit({ id, newTab }); }
  prevPage(): void { this.prevPageRequested.emit(); }
  nextPage(): void { this.nextPageRequested.emit(); }

  getDate(lead: LeadsData): string {
    if ( lead.Lead?.Number ) {
      return `${lead.Lead.Number.substring(6, 8)}.${lead.Lead.Number.substring(4, 6)}.${lead.Lead.Number.substring(0, 4)}`;
    }
    return '';
  }

  getContactName(lead: LeadsData): string {
    const contact = lead.Lead?.Contact;
    const personName = contact?.Anonymized ? '' : [contact?.FirstName, contact?.LastName].filter(Boolean).join(' ');

    return [personName, contact?.Company].filter(Boolean).join(' · ');
  }

  getAddress(lead: LeadsData): any {
    let address = AddressHelper.getLeadAddress({ ...lead.Lead.Address, Commission: lead.Lead.Commission }, '', true);
    const contactCity = lead.Lead.Contact?.City ? lead.Lead.Contact?.City + ', ' : '';
    const contactAddress = lead.Lead.Contact?.Address ? lead.Lead.Contact?.Address + ', ' : '';
    const contactZipCode = lead.Lead.Contact?.ZipCode ? lead.Lead.Contact?.ZipCode + ' ' : '';
    const commission = lead.Lead.Commission ? lead.Lead.Commission + ' ' : '';
    const mainAddress = commission + contactAddress + contactZipCode + contactCity;
    address = address ? address : mainAddress;
    address = address.replace(/^[\s,]+|[\s,]+$/gm, '');

    return { address, isAddress: !!address };
  }
}
